import styled from 'styled-components';

export const CardContainer = styled.div`
	text-align: left;
	min-height: 120px;

	.card__description {
		${props => props.theme.breakpoints.up('sm')} {
			font-size: 16px;
		}
	}
`;

export const DataContainer = styled.div`
	margin: 14px 0px 16px 0px;
	text-align: left;
`;
